// Server-owned dashboard screen discriminator. Mirrors the backend `AccountState`
// enum returned by GET /api/dashboard/profile/status (.accountState). The
// dashboard maps these to its render kinds — it never re-derives the screen from
// raw onboarding/investor/KYC status. See useDashboardState.
export const ACCOUNT_STATE = {
  ONBOARDING_PENDING: 'onboarding_pending',
  IN_REVIEW: 'in_review',
  // Re-KYC the user can self-serve, split by cause: expired (annual renew flow)
  // vs admin re-initiate / active re-verify (resubmit flow). A genuine rejection
  // is NOT here — it maps to PAUSED + PAUSED_REASON.KYC_REJECTED (terminal).
  REKYC_EXPIRED: 'rekyc_expired',
  REKYC_REJECTED: 'rekyc_rejected',
  ACTIVE: 'active',
  PAUSED: 'paused',
  GUEST: 'guest',
} as const

export type AccountStateValue = (typeof ACCOUNT_STATE)[keyof typeof ACCOUNT_STATE]

// Mirrors backend `PausedReason` — set only when accountState === 'paused'.
export const PAUSED_REASON = {
  ONBOARDING_REJECTED: 'onboarding_rejected',
  SUSPENDED: 'suspended',
  DEACTIVATED: 'deactivated',
  ACCESS_RESTRICTED: 'access_restricted',
  // KYC permanently rejected (admin reject, or any vendor rejection/reverify).
  // No self-service re-KYC — the dashboard shows a contact-us screen.
  KYC_REJECTED: 'kyc_rejected',
} as const

export type PausedReasonValue = (typeof PAUSED_REASON)[keyof typeof PAUSED_REASON]
